import Connector from './Connector';
import UcLogin from './UcLogin';
import Algolia from './Algolia';

export default {
  Connector,
  UcLogin,
  Algolia,
};
